<template>
  <div
    class="grid-wrapper"
    ref="wrapper"
    :class="{
      'is-swipable': isSwipable,
      'arrows-on-hover': renderArrows && properties.arrowsOnHover,
      'swipable-initialized': Swipeable,
    }"
    :data-swipeable="JSON.stringify(swipeableData)"
  >
    <div class="grid" ref="grid">
      <slot />
    </div>
    <div class="sg-dots" v-if="renderDots">
      <div class="sg-dot" v-for="(dot, index) in items" :key="index" />
    </div>
    <template v-if="renderArrows">
      <i class="sg-arrow sg-arrow--left c-icon icon-angle-left" />
      <i class="sg-arrow sg-arrow--right c-icon icon-angle-right" />
    </template>
  </div>
</template>

<script>
/* Todo: 

- Add support for advanced selectors 

*/

import debounce from 'lodash/debounce';

export default {
  name: 'SwipeableGrid',

  inheritAttrs: true,

  props: {
    properties: Object,
    items: {
      type: [Array, Object, Number],
    },
  },

  data: function () {
    return {
      reset: false,
      Swipeable: false,
    };
  },
  mounted() {
    this.reset = debounce((html) => {
      this._reset();
    }, 20);

    this.reset();
  },
  beforeUpdate() {},
  beforeDestroy() {
    this.destroy();
  },

  watch: {
    '$store.getters.activeDeviceType'(activeDevice) {
      setTimeout(() => {
        this.reset();
      }, 450);
    },
    properties: {
      deep: true,
      handler() {
        this.reset();
      },
    },
  },

  methods: {
    destroy() {
      const {destroy} = window.clientPlugins.swipeableGrid;

      if (this.Swipeable) {
        destroy(this.Swipeable, this.$refs.wrapper);
      }

      this.Swipeable = false;
    },
    async _reset() {
      const {create} = window.clientPlugins.swipeableGrid;
      this.destroy();

      if (!this.isSwipable) return;

      this.Swipeable = await create(
        this.$refs.wrapper,
        JSON.parse(JSON.stringify(this.swipeableData)),
        this.breakpoint,
      );

      console.log(
        this.$refs.wrapper,
        JSON.parse(JSON.stringify(this.swipeableData)),
        this.breakpoint,
      );
    },
  },

  computed: {
    breakpoint() {
      try {
        return this.$store
          ? this.$store.getters.activeDeviceType
          : window.__CONVERDY__.breakpoint;
      } catch (e) {
        return 'desktop';
      }
    },
    isSwipable() {
      return (
        this.swipeable.desktop || this.swipeable.tablet || this.swipeable.mobile
      );
    },

    renderDots() {
      return !this.isSwipable
        ? false
        : this.dots.desktop || this.dots.tablet || this.dots.mobile;
    },

    renderArrows() {
      return !this.isSwipable
        ? false
        : this.arrows.desktop || this.arrows.tablet || this.arrows.mobile;
    },

    dots() {
      return this.properties.dots;
    },

    arrows() {
      return this.properties.arrows;
    },

    swipeable() {
      return this.properties.swipeable;
    },

    swipeableData() {
      const {columns, spacing, dots, swipeable} = this.properties;

      return JSON.parse(
        JSON.stringify({
          columns,
          spacing,
          dots,
          swipeable,
        }),
      );
    },
  },
};
</script>

<style>
.grid-wrapper {
  position: relative;
  width: 100%;
  --dot-size-px: calc(var(--dot-size) * 1px);
  --arrow-size-px: calc(var(--arrow-size) * 1px);
  --arrow-bg-size-px: calc(var(--arrow-bg-size) * 1px);
}

.grid .item {
  position: relative;
  overflow: hidden; /* Added so that border radius from advanced editor applies */
}

.grid-wrapper:not(.is-swipable) .sg-dots,
.grid-wrapper:not(.is-swipable) .sg-arrow {
  display: none;
}

.sg-dots {
  position: absolute;
  z-index: 3;
  display: flex;
  width: 100%;
  justify-content: center;
  bottom: calc(var(--dot-position) * 1px);
  pointer-events: none;
  filter: drop-shadow(0px 0px 5px #0000003d);
}

.sg-dot {
  border: none;
  width: var(--dot-size-px);
  height: var(--dot-size-px);
  background: var(--dot-color);
  border-radius: 50%;
  margin: 0 4px;
  cursor: pointer;
  pointer-events: all;
}

.sg-dot:focus {
  outline: none;
}

.sg-dot--active {
  background: var(--dot-active-color);
}

.grid-wrapper.arrows-on-hover .sg-arrow {
  opacity: 0;
  transition: 300ms ease-in-out;
}

.grid-wrapper.arrows-on-hover .sg-arrow--left {
  transform: translate(10px, -50%);
}

.grid-wrapper.arrows-on-hover .sg-arrow--right {
  transform: translate(-10px, -50%);
}

.grid-wrapper.arrows-on-hover:hover .sg-arrow {
  opacity: 1;
  transform: translate(0px, -50%);
}

.sg-arrow {
  position: absolute;
  width: var(--arrow-bg-size-px);
  height: var(--arrow-bg-size-px);
  background-color: var(--arrow-bg);
  border-radius: 100%;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: var(--arrow-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--arrow-size-px);
}

.sg-arrow--left {
  left: calc(var(--arrow-position) * 1px);
}

.sg-arrow--right {
  left: auto;
  right: calc(var(--arrow-position) * 1px);
}

.sg-arrow--disabled {
  opacity: 0.6;
}

.debug {
  position: fixed;
  display: flex;
  top: 0px;
  width: 100px;
  height: 100px;
  background: red;
  color: white;
  z-index: 100000;
}
</style>
